import { TOTAL_TICKETS } from "./formatters";

const escape = (v) => {
  const s = v == null ? "" : String(v);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

const downloadCsv = (csv, filename) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const exportTicketsCsv = (tickets, year) => {
  const header = ["Ticket", "Status", "Buyer", "Phone", "Seller", "Date"];
  const rows = [header.join(",")];
  for (let i = 1; i <= TOTAL_TICKETS; i++) {
    const t = tickets[i] || { status: "available", buyer: "", phone: "", seller: "", date: "" };
    rows.push([i, t.status, t.buyer, t.phone, t.seller || t.assigned_seller_name || "", t.date].map(escape).join(","));
  }
  downloadCsv(rows.join("\n"), `400club-tickets-${year}.csv`);
};

export const exportLogCsv = (log, year) => {
  const header = ["Time", "Type", "Ticket", "Seller", "Detail"];
  const rows = [header.join(",")];
  for (const e of log) {
    rows.push([
      e.time || "",
      e.type || "",
      e.ticket_number ?? "",
      e.seller || "",
      e.text || "",
    ].map(escape).join(","));
  }
  downloadCsv(rows.join("\n"), `400club-activity-log-${year}.csv`);
};
